import type { MaskInputOptions } from 'maska';
import type { MaskType } from './types';

export const NO_SPACES_MASK: MaskInputOptions = {
  mask: 'S',
  tokens: { S: { pattern: /\S/, repeated: true } },
  tokensReplace: true,
};

/**
 * Predefined mask patterns
 * # = digit (0-9)
 * @ = letter (a-z, A-Z)
 */
export const MASK_PRESETS: Record<Exclude<MaskType, 'custom' | 'none'>, string> = {
  cpf: '###.###.###-##',
  cnpj: '##.###.###/####-##',
  phone: '(##) #####-####',
  cep: '#####-###',
  date: '##/##/####',
  time: '##:##',
  email: '*@*.*',
  money: 'R$ #.###,##',
  weight: '###.### kg',
  measure: '###.### cm',
  register_number: '######',
} as const;

export const MASK_LABELS: Record<MaskType, string> = {
  cpf: 'CPF (###.###.###-##)',
  cnpj: 'CNPJ (##.###.###/####-##)',
  phone: 'Telefone ((##) #####-####)',
  cep: 'CEP (#####-###)',
  date: 'Data (##/##/####)',
  time: 'Hora (##:##)',
  email: 'E-mail',
  money: 'Valores monetários',
  weight: 'Peso (kg)',
  measure: 'Medida (cm)',
  register_number: 'Matrícula (######)',
  custom: 'Customizada',
  none: 'Nenhuma',
} as const;
